import { unit } from '../../common/theme/index';
import { styled } from '../../providers/context/StyletronProvider/withStyletronProvider';

export const Tasks = styled('div', () => ({
  marginBottom: unit[6],
  display: 'grid',
  gridTemplateRows: 'repeat(4)',
  gridGap: unit[3],
}));
